import { ComplianceItemCard } from '@cogneed/design-system';
import { useTranslation } from 'react-i18next';
import { ComplianceChecklistItemStatus } from '../../../../generated/core-api/graphql-react-query';
import { SessionComplianceChecklistItem } from '../../../LiveContext/NewSessionContext/Contexts/SessionComplianceContextProvider/type';
import complianceStatusTag from '../complianceStatusTag';
import ComplianceItemContent from '../ComplianceItemContent';
import ComplianceProcessedGroup from '../ComplianceProcessedGroup';
import TopicTag from '../TopicTag';
import StyledBox from './styles';

interface ComplianceListProps {
  items: SessionComplianceChecklistItem[];
  density: 'panel' | 'page';
}

// Shared rendering for the compliance checklist -- used by both the 380px
// session panel and the full-width Session Live page, the only difference
// between them being `density` (and the panel/page each wrapping this in
// their own header chrome and empty state). Pending items lay out as a
// single column in the panel, a two-column grid on the page; the processed
// group is always one full-width block below.
export default function ComplianceList(props: ComplianceListProps) {
  const { items, density } = props;
  const { t } = useTranslation();

  const pending = items.filter((item) => item.result === ComplianceChecklistItemStatus.NotValidated);
  const processed = items.filter((item) => item.result !== ComplianceChecklistItemStatus.NotValidated);

  return (
    <StyledBox density={density}>
      {pending.length > 0 && (
        <div className="compliancePendingItems">
          {pending.map((item) => (
            <ComplianceItemCard
              key={item.textLower}
              title={<TopicTag text={item.topic.text} color={item.topic.color} density={density} />}
              status={complianceStatusTag(item.result, t)}
              density={density}
            >
              <ComplianceItemContent item={item} density={density} />
            </ComplianceItemCard>
          ))}
        </div>
      )}
      {processed.length > 0 && (
        <ComplianceProcessedGroup items={processed} density={density} defaultOpen={density === 'page'} />
      )}
    </StyledBox>
  );
}
